import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import axios from "axios";
import App2 from "./app2.js/App2";
import { applyRequestHmac } from "./apiService/hmacUtils";
import "./app/App.scss";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import "remixicon/fonts/remixicon.css";
import "react-image-crop/dist/ReactCrop.css";
import "react-image-crop/src/ReactCrop.scss";
import { LanguageProvider } from "./app2.js/Components/LanguageContext";
import { ThemeProvider } from "./ThemeContext";

axios.interceptors.request.use((config) => {
  const base = process.env.REACT_APP_API_BASE_URL || "";
  if (base && String(config.url || "").startsWith(base)) {
    return applyRequestHmac(config);
  }
  return config;
});

ReactDOM.render(
  <BrowserRouter>
  <ThemeProvider>
    <LanguageProvider>
    <App2 />
    </LanguageProvider>
  </ThemeProvider>
  </BrowserRouter>,
  document.getElementById("root")
);

serviceWorkerRegistration.register();
